<template>
  <div>
    <div v-if="showModalSuccess">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    @click="$emit('close')"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/noti-success2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messSuccess }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    v-if="hasAction"
                    type="button"
                    class="btn btn-light"
                    data-dismiss="modal"
                    @click="submit()"
                  >
                    Đóng
                  </button>
                  <button
                    v-else
                    type="button"
                    class="btn btn-light"
                    data-dismiss="modal"
                    @click="$emit('close')"
                  >
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['showModalSuccess', 'messSuccess', 'hasAction', 'route'],
    data() {
      return {}
    },
    methods: {
      submit() {
        this.$router.push({ path: this.route })
      },
    },
  }
</script>

<style scoped></style>
